import Axios from "./axios";

const endpoint = "/api/approval";

export default {
  //메모 리스트
  //{orderId:1}
  approvalMemoList: (payload) => Axios.post(`${endpoint}/memo-list`, payload),

  //승인
  approval: (approvalYn, orderId, companyId) =>
    Axios.post(`${endpoint}/approval`, {
      approvalYn: approvalYn,
      orderId: orderId,
      companyId: companyId,
    }),

  //메모 추가
  approvalInsertMemo: (payload) =>
    Axios.post(`${endpoint}/memo-insert`, payload),

  //승인 / 수정 히스토리
  approvalTotalList: (payload) =>
    Axios.post(`${endpoint}/approval-list`, payload),

  //메모 리스트 형태로 추가 (발주입고부분에서 적용)
  approvalInsertList: (payload) =>
    Axios.post(`${endpoint}/memo-list-insert`, { memoList: payload }),

  //orderId로 다운로드 여부 확인
  approvalDownCheck: (orderId) =>
    Axios.get(`${endpoint}/download-check?orderId=${orderId}`),

  //허용 취소 부분
  approvalRollBack: (orderId) =>
    Axios.post(`${endpoint}/approval-rollback`, {
      orderId: orderId,
    }),
};
